import { Button, Flex, Image, Menu, MenuButton, MenuList, MenuItem } from '@chakra-ui/react'
import Logo from 'assets/images/logo.jpg'
import { useNavigate } from 'react-router-dom'
import { clearToken, getAssetUrl } from 'lib'
import { useAppContext } from 'hooks/useAppContext'

export const Topbar = () => {
  const navigate = useNavigate()
  const { currentUser } = useAppContext()

  const handleLogout = () => {
    clearToken()
    window.location.reload()
  }

  return (
    <Flex
      justifyContent="space-between"
      alignItems="center"
      px={10}
      position="fixed"
      top={0}
      width="100%"
      height="60px"
      boxShadow="0px 1px 3px gray"
      zIndex={1000}
      bg="white"
    >
      <Image w="220px" src={Logo} alt="topnav logo" />
      <Menu>
        <MenuButton as={Button} variant="ghost" p={0}>
          <Image w="40px" src={getAssetUrl(currentUser?.image)} borderRadius="full" />
        </MenuButton>
        <MenuList>
          <MenuItem onClick={() => navigate('/system/profile')}>Settings</MenuItem>
          <MenuItem onClick={handleLogout}>Logout</MenuItem>
        </MenuList>
      </Menu>
    </Flex>
  )
}
